<div class="section border-bottom">
    <div class="video flex-1 d-flex p-1">

        <div class="loader d-flex flex-stretch justify-content-center align-items-center"
            *ngIf="!video && !errorMessage">
            <kui-loader>
            </kui-loader>
        </div>

        <kui-alert-panel [size]="3"
            [message]="errorMessage"></kui-alert-panel>

        <key-video *ngIf="!errorMessage && video"
            [asset]="asset"
            [video]="video"
            [controls]="true"
            [download]="false"
            ></key-video>

    </div>
</div>